import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles<{ additionalFooterSpacing: boolean }>({
  allRightsReserved: theme => css`
    color: ${theme.colors.neutral[200]};
  `,

  supportLink: theme => css`
    display: flex;
    justify-content: center;
    color: ${theme.colors.brand.primary[300]};
    cursor: pointer;
    margin-top: ${theme.spacing.xxs};
    @media (min-width: ${theme.grid.breakpoint.lg}) {
      margin-bottom: ${theme.spacing.xxs};
    }
  `,

  contentFooter: (theme, { additionalFooterSpacing }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    align-self: center;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    bottom: 0;
    width: 100%;
    gap: ${theme.spacing.xxs};
    flex-grow: 1;
    margin-bottom: ${theme.spacing.xxs};
    padding-left: ${additionalFooterSpacing ? theme.spacing.lg : 0};
    p {
      color: ${theme.colors.neutral[200]};
    }
  `,
})

export default useStyles
